import { useContext, useEffect, useState } from 'react';
import GlobalContext from '~/context/vdp/GlobalContext';

export default function useAddExperimentToContext(
  experimentName: string,
  assignedBucket: string
): boolean {
  const { setExperimentsWithBucket } = useContext(GlobalContext);
  const [didLoad, setDidLoad] = useState(false);

  useEffect(() => {
    if (assignedBucket == null) return;
    setExperimentsWithBucket(prev => ({
      ...prev,
      [experimentName]: assignedBucket
    }));
    setDidLoad(true);
  }, [assignedBucket, experimentName, setExperimentsWithBucket]);

  return didLoad;
}
